import { createApi } from '@/api'
export default {
	getPermissionList: config => createApi( `/permission/pageSearch`, 'post', config ),
	permissionDetail: config => createApi(`/permission/get`, 'get', config),
	addpermission: config => createApi(`/permission/add`, 'post', config),
	deletepermission: config => createApi(`/permission/delete`, 'delete', config),
	updatepermission: config => createApi(`/permission/update`, 'post', config)
}



// WEBPACK FOOTER //
// ./src/views/permissionManage/api/index.js